import { render, staticRenderFns } from "./SocialStreamConfigs.vue?vue&type=template&id=0de94de0&lang=html"
import script from "./SocialStreamConfigs.vue?vue&type=script&lang=ts"
export * from "./SocialStreamConfigs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports